import Text_styles from '@/components/Editor/StylesProperties/Text_Styles'
import { merge_default_values } from '@/utils/mergeDefaultValue'
import { background_styles } from 'constant/BackgroundStyles'
import { border_styles } from 'constant/BordersStyle'
import {
  common_button_links,
  common_button_styles,
  common_button_styles_fields,
  common_card_styles_fields,
  common_card_styles_fields_2,
  common_image_styles,
  common_sizes_fields,
  position_styles,
  spacing_styles,
} from 'constant/CommonStylesData'
import { link_target_values } from 'constant/constant_values'
import { layout_styles } from 'constant/LayoutStylesData'
import { row_layout_styles } from 'constant/RowLayout'
import { typography_styles } from 'constant/TypographyStyles'
import { account_filter_types_list, filter_types_list } from 'data/FilterData'

export const common_blocks_list = [
  {
    id: 1,
    title: 'Empty Block',
    image: '/img/block-empty.png',
    type: 'marketplace,single_shop',
    properties: {
      block: 'empty_block',
      block_data_key: '',
      fetch_by: {},
      isStatic: true,
      data_fields: [],
      styles_fields: [
        {
          group_key: 'main_styles',
          group_title: 'Block styles',
          styles_list: [
            ...merge_default_values({
              all_items: common_card_styles_fields,
              ...position_styles,
              default_values_items: [],
            }),
          ],
        },
        {
          group_key: 'box_styles',
          group_title: 'Content Styles',
          styles_list: [
            ...background_styles,
            ...common_sizes_fields,
            ...merge_default_values({
              all_items: spacing_styles,
              default_values_items: [
                { key: 'padding_bottom', value: '8px' },
                { key: 'padding_top', value: '8px' },
                { key: 'padding_right', value: '8px' },
                { key: 'padding_left', value: '8px' },
              ],
            }),

            ...merge_default_values({
              all_items: layout_styles,
              default_values_items: [{ key: 'align_items', value: 'center' }],
              remove_items: ['flex_direction'],
            }),
          ],
        },
      ],
    },
  },
  {
    id: 6,
    title: 'Divider',
    image: '/img/block-divider.png',
    type: 'marketplace,single_shop',
    properties: {
      block: 'divider_block',
      block_data_key: '',
      fetch_by: {},
      isStatic: true,
      data_fields: [],
      styles_fields: [
        {
          group_key: 'divider_styles',
          group_title: 'Divider styles',
          styles_list: merge_default_values({
            all_items: [
              ...common_sizes_fields,
              ...background_styles,
              ...spacing_styles,
              ...border_styles,
              {
                key: 'box_shadow',
                default_component_key: 'shadow',
                value: '0px 0px 0px 0px #ffffff',
                type: 'shadow-picker',
                title: 'Shadow',
              },
            ],
            default_values_items: [
              { key: 'background', value: '#4A90E2' },
              { key: 'height', value: '1px' },
            ],
          }),
        },
      ],
    },
  },
  {
    id: 13,
    title: 'OPP KYC',
    image: '/img/opp/opp-kyc3.png',
    type: '',
    properties: {
      block: 'opp_setup_button',
      isStatic: true,
      block_data_key: '',
      fetch_by: {},
      isShowTranslation: true,
      data_fields: [
        {
          key: 'isEnabled',
          title: '',
          type: 'switch',
          value: true,
          isShowWithTitle: true,
        },
        {
          key: 'button_title',
          title: 'Button title',
          type: 'input',
          value: '',
          is_required: true,
          isShowTranslation: true,
        },

        {
          key: 'icon',
          title: 'Icon URL',
          type: 'image',
          value: '',
          is_required: false,
        },
      ],
      styles_fields: [
        {
          group_key: 'main_styles',
          group_title: 'Block styles',
          styles_list: [
            ...merge_default_values({
              all_items: common_card_styles_fields,
              default_values_items: [],
            }),
          ],
        },
        {
          group_key: 'box_styles',
          group_title: 'Content styles',
          styles_list: [
            ...merge_default_values({
              all_items: common_card_styles_fields,
              default_values_items: [],
            }),
          ],
        },
        {
          group_key: 'button_styles',
          group_title: 'Button styles',
          styles_list: [...common_button_styles_fields],
        },
        {
          group_key: 'text_styles',
          group_title: 'Title text styles',
          styles_list: [...typography_styles],
        },
        {
          group_key: 'icon_styles',
          group_title: 'Icon styles',
          styles_list: [...typography_styles],
        },
      ],
    },
  },
  {
    id: 13,
    title: 'Add Amount button',
    image: '/img/block-button.png',
    type: '',
    properties: {
      block: 'add_amount_in_wallet_button',
      isStatic: true,
      block_data_key: '',
      fetch_by: {},
      isShowTransition: true,
      data_fields: [
        {
          key: 'isEnabled',
          title: '',
          type: 'switch',
          value: true,
          isShowWithTitle: true,
        },
        {
          key: 'button_title',
          title: 'Button title',
          type: 'input',
          value: '',
          is_required: true,
          isShowTransition: true,
        },

        {
          key: 'icon',
          title: 'Icon URL',
          type: 'image',
          value: '',
          is_required: false,
        },
      ],
      styles_fields: [
        {
          group_key: 'main_styles',
          group_title: 'Block styles',
          styles_list: [
            ...merge_default_values({
              all_items: common_card_styles_fields,
              default_values_items: [],
            }),
          ],
        },
        {
          group_key: 'box_styles',
          group_title: 'Content styles',
          styles_list: [
            ...merge_default_values({
              all_items: common_card_styles_fields,
              default_values_items: [],
            }),
          ],
        },
        {
          group_key: 'button_styles',
          group_title: 'Button styles',
          styles_list: [...common_button_styles_fields],
        },
        {
          group_key: 'text_styles',
          group_title: 'Title text styles',
          styles_list: [...typography_styles],
        },
        {
          group_key: 'icon_styles',
          group_title: 'Icon styles',
          styles_list: [...typography_styles],
        },
      ],
    },
  },

  {
    id: 13,
    title: 'Stripe KYC',
    image: '/img/stripe-kyc.png',
    type: '',
    properties: {
      block: 'stripe_setup_button',
      isStatic: true,
      block_data_key: '',
      fetch_by: {},
      isShowTranslation: true,
      data_fields: [
        {
          key: 'isEnabled',
          title: '',
          type: 'switch',
          value: true,
          isShowWithTitle: true,
        },
        {
          key: 'button_title',
          title: 'Button title',
          type: 'input',
          value: '',
          is_required: true,
          isShowTranslation: true,
        },

        {
          key: 'icon',
          title: 'Icon URL',
          type: 'image',
          value: '',
          is_required: false,
        },
      ],
      styles_fields: [
        {
          group_key: 'main_styles',
          group_title: 'Block styles',
          styles_list: [
            ...merge_default_values({
              all_items: common_card_styles_fields,
              default_values_items: [],
            }),
          ],
        },
        {
          group_key: 'box_styles',
          group_title: 'Content styles',
          styles_list: [
            ...merge_default_values({
              all_items: common_card_styles_fields,
              default_values_items: [],
            }),
          ],
        },
        {
          group_key: 'button_styles',
          group_title: 'Button styles',
          styles_list: [...common_button_styles_fields],
        },
        {
          group_key: 'text_styles',
          group_title: 'Title text styles',
          styles_list: [...typography_styles],
        },
        {
          group_key: 'icon_styles',
          group_title: 'Icon styles',
          styles_list: [...typography_styles],
        },
      ],
    },
  },
  {
    id: 13,
    title: 'Navbar',
    image: '/img/block-navbar.png',
    type: '',
    properties: {
      block: 'custom_navbar',
      isStatic: true,
      block_data_key: '',
      fetch_by: {},
      isShowTranslation: true,
      data_fields: [
        {
          key: 'isEnabled',
          title: '',
          type: 'switch',
          value: true,
          isShowWithTitle: true,
        },
        {
          key: 'nav_items',
          title: 'Nav Item',
          type: 'array',
          value: [],
          drop_down_interface: {
            button_title: 'Add menu',
            isShowTranslation: true,
            fields: [
              {
                key: 'title',
                title: 'Title',
                type: 'input',
                value: '',
                isShowValueInList: true,
                isShowTranslation: true,
                is_required: true,
              },
              {
                key: 'href',
                title: 'Link',
                type: 'input',
                value: '',
                isShowValueInList: true,
                is_required: true,
              },

              {
                key: 'image',
                title: 'Image',
                type: 'image',
                value: '',
                is_required: true,
              },
            ],
          },
          is_required: true,
        },
      ],
      styles_fields: [
        {
          group_key: 'main_styles',
          group_title: 'Block styles',
          styles_list: [
            ...merge_default_values({
              all_items: common_card_styles_fields,
              default_values_items: [],
            }),
          ],
        },
        {
          group_key: 'box_styles',
          group_title: 'Content styles',
          styles_list: [...common_card_styles_fields, ...row_layout_styles],
        },
        {
          group_key: 'nav_item',
          group_title: 'Nav Item',
          styles_list: [
            ...spacing_styles,
            ...common_sizes_fields,
            ...background_styles,
            ...row_layout_styles,
            ...position_styles,
          ],
        },

        {
          group_key: 'nav_item_title',
          group_title: 'Title',
          styles_list: [...common_sizes_fields, ...typography_styles, ...spacing_styles],
        },
        {
          group_key: 'nav_item_image',
          group_title: 'Image',
          styles_list: [...common_image_styles],
        },
        {
          group_key: 'active_style',
          group_title: 'Active style',
          styles_list: [
            ...common_sizes_fields,
            ...background_styles,
            ...spacing_styles,
            ...position_styles,
            ...border_styles,
          ],
        },
      ],
    },
  },
  {
    id: 13,
    title: 'Custom Listing Filter',
    image: '/img/block-custom_filter.png',
    type: '',
    properties: {
      block: 'custom_filter',
      isStatic: true,
      block_data_key: '',
      fetch_by: {},
      isShowTranslation: true,
      data_fields: [
        {
          key: 'isEnabled',
          title: '',
          type: 'switch',
          value: true,
          isShowWithTitle: true,
        },
        {
          key: 'filter_items',
          title: 'Filter Items',
          type: 'array',
          value: [],
          drop_down_interface: {
            button_title: 'Add Filter Field',
            isShowTranslation: true,
            fields: [
              {
                key: 'is_show_title',
                title: 'Title',
                type: 'switch',
                value: true,
              },
              {
                key: 'is_depend_on_search',
                title: 'Connect with search button',
                type: 'switch',
                value: true,
              },
              {
                key: 'is_connected_to_category',
                title: 'Load attributes by category',
                type: 'switch',
                value: false,
                condition: {
                  keys: ['filter_type'],
                  match_value: [
                    'single-select-attribute',
                    'multi-select-attribute',
                    'multi-value-attribute',
                    'single-select-radio-attribute',
                  ],
                },
              },
              {
                key: 'title',
                title: 'Title',
                type: 'input',
                value: '',
                isShowValueInList: true,
                isShowTranslation: true,
                is_required: true,
              },
              {
                key: 'filter_type',
                title: 'Select Type',
                type: 'select',
                value: '',
                is_required: true,
                drop_down_values: [...filter_types_list],
              },
              {
                key: 'sorting_type',
                title: 'Select Sorting Type',
                type: 'select',
                value: 'single-select',
                is_required: true,
                is_show: false,
                condition: {
                  keys: ['filter_type'],
                  match_value: ['sorting'],
                },
              },
              {
                key: 'url',
                title: 'Search URL',
                type: 'input',
                value: '/l',
                is_required: false,
                condition: {
                  keys: ['filter_type'],
                  match_value: ['search-button'],
                },
              },
              {
                key: 'category_ids',
                title: 'Select Categories',
                type: 'multi-select',
                value: '',
                is_required: true,
                is_fetch_data: true,
                extra_data: {
                  path: '/api/v2/category?type=listings&parent=0',
                  label_key: 'name',
                  value_key: 'id',
                  type: 'category',
                },
                drop_down_values: [],
                condition: {
                  keys: ['filter_type'],
                  match_value: ['category'],
                },
              },
              {
                key: 'attribute_id',
                title: 'Select Attribute',
                type: 'select',
                value: '',
                is_required: true,
                is_fetch_data: true,
                extra_data: {
                  path: '/api/attributes?type=listings',
                  label_key: 'name',
                  value_key: 'id',
                },
                drop_down_values: [],
                condition: {
                  keys: ['filter_type'],
                  match_value: [
                    'single-select-attribute',
                    'multi-select-attribute',
                    'multi-value-attribute',
                    'location-attribute',
                    'date-attribute',
                    'single-select-radio-attribute',
                  ],
                },
              },
              {
                key: 'search_icon_image',
                title: 'Icon',
                type: 'image',
                value: '',
                condition: {
                  keys: ['filter_type'],
                  match_value: ['search-button'],
                },
              },
              {
                key: 'max_distance',
                title: 'Max. Distance',
                type: 'number',
                value: 10,
                condition: {
                  keys: ['filter_type'],
                  match_value: ['nearest-area-search'],
                },
              },
            ],
          },
          is_required: true,
        },
      ],
      styles_fields: [
        {
          group_key: 'main_styles',
          group_title: 'Block styles',
          styles_list: [
            ...merge_default_values({
              all_items: common_card_styles_fields,
              default_values_items: [],
            }),
          ],
        },
        {
          group_key: 'box_styles',
          group_title: 'Content styles',
          styles_list: [...common_card_styles_fields, ...row_layout_styles],
        },
        {
          group_key: 'filter_component_style',
          group_title: 'Filter list component style',
          styles_list: [
            ...merge_default_values({
              all_items: common_card_styles_fields,
              default_values_items: [],
            }),
            ...merge_default_values({
              all_items: layout_styles,
              default_values_items: [
                { key: 'row_gap', value: '18px' },
                { key: 'column_gap', value: '18px' },
              ],
            }),
          ],
        },
        {
          group_key: 'filter_title_style',
          group_title: 'Title styles',
          styles_list: merge_default_values({
            all_items: [...typography_styles, ...layout_styles, ...spacing_styles],
            default_values_items: [
              {
                key: 'text_size',
                value: '18px',
              },
              {
                key: 'line_height',
                value: '18px',
              },
              {
                key: 'text_color',
                value: '#000000',
              },
              {
                key: 'margin_bottom',
                value: '4px',
              },
            ],
          }),
          condition: {
            where: 'data_fields',
            keys: ['filter_items'],
            type: 'Array',
            filter_key: 'is_show_title',
            match_value: [true],
          },
        },
        {
          group_key: 'filter_category_menu_style',
          group_title: 'Category Menu styles',
          styles_list: merge_default_values({
            all_items: [
              ...typography_styles,
              ...layout_styles,
              ...spacing_styles,
              ...common_sizes_fields,
            ],
            default_values_items: [
              {
                key: 'flex_direction',
                value: 'row',
              },
              {
                key: 'align_items',
                value: 'center',
              },
              {
                key: 'justify_content',
                value: 'space-between',
              },

              {
                key: 'text_size',
                value: '14px',
              },
              {
                key: 'line_height',
                value: '14px',
              },
              {
                key: 'text_color',
                value: '#3E3D3D',
              },
              {
                key: 'margin_top',
                value: '8px',
              },
            ],
          }),
          condition: {
            where: 'data_fields',
            keys: ['filter_items'],
            type: 'Array',
            filter_key: 'filter_type',
            match_value: ['category'],
          },
        },

        {
          group_key: 'filter_date_filed_style',
          group_title: 'Date styles',
          styles_list: merge_default_values({
            all_items: [
              ...typography_styles,
              ...spacing_styles,
              ...common_sizes_fields,
              ...background_styles,
              ...border_styles,
            ],
            default_values_items: [
              {
                key: 'text_size',
                value: '14px',
              },
              {
                key: 'line_height',
                value: '14px',
              },
              {
                key: 'text_color',
                value: '#3E3D3D',
              },
            ],
          }),
          condition: {
            where: 'data_fields',
            keys: ['filter_items'],
            type: 'Array',
            filter_key: 'filter_type',
            match_value: ['date-attribute'],
          },
        },
        {
          group_key: 'filter_location_filed_style',
          group_title: 'Location styles',
          styles_list: merge_default_values({
            all_items: [
              ...typography_styles,
              ...spacing_styles,
              ...common_sizes_fields,
              ...background_styles,
              ...border_styles,
            ],
            default_values_items: [
              {
                key: 'text_size',
                value: '14px',
              },
              {
                key: 'line_height',
                value: '14px',
              },
              {
                key: 'text_color',
                value: '#3E3D3D',
              },
            ],
          }),
          condition: {
            where: 'data_fields',
            keys: ['filter_items'],
            type: 'Array',
            filter_key: 'filter_type',
            match_value: ['location-attribute'],
          },
        },
        {
          group_key: 'filter_single_select_filed_style',
          group_title: 'Single Select styles',
          styles_list: merge_default_values({
            all_items: [
              ...typography_styles,
              ...spacing_styles,
              ...common_sizes_fields,
              ...background_styles,
              ...border_styles,
              ...layout_styles,
            ],
            default_values_items: [
              {
                key: 'text_size',
                value: '14px',
              },
              {
                key: 'line_height',
                value: '14px',
              },
              {
                key: 'text_color',
                value: '#3E3D3D',
              },
            ],
          }),
          condition: {
            where: 'data_fields',
            keys: ['filter_items'],
            type: 'Array',
            filter_key: 'filter_type',
            match_value: ['single-select-attribute', 'sorting'],
          },
        },
        {
          group_key: 'filter_single_select_radio_style',
          group_title: 'Single Select Menu styles',
          styles_list: merge_default_values({
            all_items: [
              ...typography_styles,
              ...layout_styles,
              ...spacing_styles,
              ...common_sizes_fields,
            ],
            default_values_items: [
              {
                key: 'flex_direction',
                value: 'row',
              },
              {
                key: 'align_items',
                value: 'center',
              },
              {
                key: 'justify_content',
                value: 'space-between',
              },

              {
                key: 'text_size',
                value: '14px',
              },
              {
                key: 'line_height',
                value: '14px',
              },
              {
                key: 'text_color',
                value: '#3E3D3D',
              },
              {
                key: 'margin_top',
                value: '8px',
              },
            ],
          }),
          condition: {
            where: 'data_fields',
            keys: ['filter_items'],
            type: 'Array',
            filter_key: 'filter_type',
            match_value: ['single-select-radio-attribute'],
          },
        },
        {
          group_key: 'filter_search_button_style',
          group_title: 'Search Button styles',
          styles_list: merge_default_values({
            all_items: [...common_button_styles, ...layout_styles],
          }),
          condition: {
            where: 'data_fields',
            keys: ['filter_items'],
            type: 'Array',
            filter_key: 'filter_type',
            match_value: ['search-button'],
          },
        },
        {
          group_key: 'filter_search_button_image_style',
          group_title: 'Search Button Icon style',
          styles_list: merge_default_values({
            all_items: [...common_image_styles],
          }),
          condition: {
            where: 'data_fields',
            keys: ['filter_items'],
            type: 'Array',
            filter_key: 'filter_type',
            match_value: ['search-button'],
          },
        },
      ],
    },
  },
  {
    id: 13,
    title: 'Custom Account Filter',
    image: '/img/block-custom_filter.png',
    type: '',
    properties: {
      block: 'custom_account_filter',
      isStatic: true,
      block_data_key: '',
      fetch_by: {},
      isShowTranslation: true,
      data_fields: [
        {
          key: 'isEnabled',
          title: '',
          type: 'switch',
          value: true,
          isShowWithTitle: true,
        },
        {
          key: 'filter_items',
          title: 'Filter Items',
          type: 'array',
          value: [],
          drop_down_interface: {
            button_title: 'Add Filter Field',
            isShowTranslation: true,
            fields: [
              {
                key: 'is_show_title',
                title: 'Title',
                type: 'switch',
                value: true,
              },
              {
                key: 'is_depend_on_search',
                title: 'Connect with search button',
                type: 'switch',
                value: true,
              },
              {
                key: 'title',
                title: 'Title',
                type: 'input',
                value: '',
                isShowValueInList: true,
                isShowTranslation: true,
                is_required: true,
              },
              {
                key: 'filter_type',
                title: 'Select Type',
                type: 'select',
                value: '',
                is_required: true,
                drop_down_values: [...account_filter_types_list],
              },
              {
                key: 'sorting_type',
                title: 'Select Sorting Type',
                type: 'select',
                value: 'single-select',
                is_required: true,
                is_show: false,
                condition: {
                  keys: ['filter_type'],
                  match_value: ['sorting'],
                },
              },
              {
                key: 'url',
                title: 'Search URL',
                type: 'input',
                value: '/a',
                is_required: false,
                condition: {
                  keys: ['filter_type'],
                  match_value: ['search-button'],
                },
              },
              {
                key: 'category_ids',
                title: 'Select Categories',
                type: 'multi-select',
                value: '',
                is_required: true,
                is_fetch_data: true,
                extra_data: {
                  path: '/api/v2/category?type=accounts&parent=0',
                  label_key: 'name',
                  value_key: 'id',
                },
                drop_down_values: [],
                condition: {
                  keys: ['filter_type'],
                  match_value: ['category'],
                },
              },
              {
                key: 'attribute_id',
                title: 'Select Attribute',
                type: 'select',
                value: '',
                is_required: true,
                is_fetch_data: true,
                extra_data: {
                  path: '/api/attributes?type=accounts',
                  label_key: 'name',
                  value_key: 'id',
                },
                drop_down_values: [],
                condition: {
                  keys: ['filter_type'],
                  match_value: [
                    'single-select-attribute',
                    'multi-select-attribute',
                    'multi-value-attribute',
                    'location-attribute',
                    'date-attribute',
                    'single-select-radio-attribute',
                  ],
                },
              },
              {
                key: 'search_icon_image',
                title: 'Icon',
                type: 'image',
                value: '',
                condition: {
                  keys: ['filter_type'],
                  match_value: ['search-button'],
                },
              },
            ],
          },
          is_required: true,
        },
      ],
      styles_fields: [
        {
          group_key: 'main_styles',
          group_title: 'Block styles',
          styles_list: [
            ...merge_default_values({
              all_items: common_card_styles_fields,
              default_values_items: [],
            }),
          ],
        },
        {
          group_key: 'box_styles',
          group_title: 'Content styles',
          styles_list: [...common_card_styles_fields, ...row_layout_styles],
        },
        {
          group_key: 'filter_component_style',
          group_title: 'Filter list component style',
          styles_list: [
            ...merge_default_values({
              all_items: common_card_styles_fields,
              default_values_items: [],
            }),
            ...merge_default_values({
              all_items: layout_styles,
              default_values_items: [
                { key: 'row_gap', value: '18px' },
                { key: 'column_gap', value: '18px' },
              ],
            }),
          ],
        },
        {
          group_key: 'filter_title_style',
          group_title: 'Title styles',
          styles_list: merge_default_values({
            all_items: [...typography_styles, ...layout_styles, ...spacing_styles],
            default_values_items: [
              {
                key: 'text_size',
                value: '18px',
              },
              {
                key: 'line_height',
                value: '18px',
              },
              {
                key: 'text_color',
                value: '#000000',
              },
              {
                key: 'margin_bottom',
                value: '4px',
              },
            ],
          }),
          condition: {
            where: 'data_fields',
            keys: ['filter_items'],
            type: 'Array',
            filter_key: 'is_show_title',
            match_value: [true],
          },
        },
        {
          group_key: 'filter_category_menu_style',
          group_title: 'Category Menu styles',
          styles_list: merge_default_values({
            all_items: [
              ...typography_styles,
              ...layout_styles,
              ...spacing_styles,
              ...common_sizes_fields,
            ],
            default_values_items: [
              {
                key: 'flex_direction',
                value: 'row',
              },
              {
                key: 'align_items',
                value: 'center',
              },
              {
                key: 'justify_content',
                value: 'space-between',
              },

              {
                key: 'text_size',
                value: '14px',
              },
              {
                key: 'line_height',
                value: '14px',
              },
              {
                key: 'text_color',
                value: '#3E3D3D',
              },
              {
                key: 'margin_top',
                value: '8px',
              },
            ],
          }),
          condition: {
            where: 'data_fields',
            keys: ['filter_items'],
            type: 'Array',
            filter_key: 'filter_type',
            match_value: ['category'],
          },
        },

        {
          group_key: 'filter_date_filed_style',
          group_title: 'Date styles',
          styles_list: merge_default_values({
            all_items: [
              ...typography_styles,
              ...spacing_styles,
              ...common_sizes_fields,
              ...background_styles,
              ...border_styles,
            ],
            default_values_items: [
              {
                key: 'text_size',
                value: '14px',
              },
              {
                key: 'line_height',
                value: '14px',
              },
              {
                key: 'text_color',
                value: '#3E3D3D',
              },
            ],
          }),
          condition: {
            where: 'data_fields',
            keys: ['filter_items'],
            type: 'Array',
            filter_key: 'filter_type',
            match_value: ['date-attribute'],
          },
        },
        {
          group_key: 'filter_location_filed_style',
          group_title: 'Location styles',
          styles_list: merge_default_values({
            all_items: [
              ...typography_styles,
              ...spacing_styles,
              ...common_sizes_fields,
              ...background_styles,
              ...border_styles,
            ],
            default_values_items: [
              {
                key: 'text_size',
                value: '14px',
              },
              {
                key: 'line_height',
                value: '14px',
              },
              {
                key: 'text_color',
                value: '#3E3D3D',
              },
            ],
          }),
          condition: {
            where: 'data_fields',
            keys: ['filter_items'],
            type: 'Array',
            filter_key: 'filter_type',
            match_value: ['location-attribute'],
          },
        },
        {
          group_key: 'filter_single_select_filed_style',
          group_title: 'Single Select styles',
          styles_list: merge_default_values({
            all_items: [
              ...typography_styles,
              ...spacing_styles,
              ...common_sizes_fields,
              ...background_styles,
              ...border_styles,
              ...layout_styles,
            ],
            default_values_items: [
              {
                key: 'text_size',
                value: '14px',
              },
              {
                key: 'line_height',
                value: '14px',
              },
              {
                key: 'text_color',
                value: '#3E3D3D',
              },
            ],
          }),
          condition: {
            where: 'data_fields',
            keys: ['filter_items'],
            type: 'Array',
            filter_key: 'filter_type',
            match_value: ['single-select-attribute', 'sorting'],
          },
        },
        {
          group_key: 'filter_single_select_radio_style',
          group_title: 'Single Select Menu styles',
          styles_list: merge_default_values({
            all_items: [
              ...typography_styles,
              ...layout_styles,
              ...spacing_styles,
              ...common_sizes_fields,
            ],
            default_values_items: [
              {
                key: 'flex_direction',
                value: 'row',
              },
              {
                key: 'align_items',
                value: 'center',
              },
              {
                key: 'justify_content',
                value: 'space-between',
              },

              {
                key: 'text_size',
                value: '14px',
              },
              {
                key: 'line_height',
                value: '14px',
              },
              {
                key: 'text_color',
                value: '#3E3D3D',
              },
              {
                key: 'margin_top',
                value: '8px',
              },
            ],
          }),
          condition: {
            where: 'data_fields',
            keys: ['filter_items'],
            type: 'Array',
            filter_key: 'filter_type',
            match_value: ['single-select-radio-attribute'],
          },
        },
        {
          group_key: 'filter_search_button_style',
          group_title: 'Search Button styles',
          styles_list: merge_default_values({
            all_items: [...common_button_styles, ...layout_styles],
          }),
          condition: {
            where: 'data_fields',
            keys: ['filter_items'],
            type: 'Array',
            filter_key: 'filter_type',
            match_value: ['search-button'],
          },
        },
        {
          group_key: 'filter_search_button_image_style',
          group_title: 'Search Button Icon style',
          styles_list: merge_default_values({
            all_items: [...common_image_styles],
          }),
          condition: {
            where: 'data_fields',
            keys: ['filter_items'],
            type: 'Array',
            filter_key: 'filter_type',
            match_value: ['search-button'],
          },
        },
      ],
    },
  },
  {
    id: 3,
    title: 'All Accounts (Latest)',
    image: '/img/block-collection.png',
    type: 'marketplace,single_shop',
    properties: {
      block: 'dynamic_all_accounts',
      block_data_key: 'accounts',
      fetch_by: {},
      isStatic: true,
      data_fields: [
        {
          key: 'per_page',
          title: 'Per page',
          type: 'number',
          value: 20,
          is_show: true,
        },

        {
          key: 'pagination_type',
          title: 'Pagination type',
          type: 'select',
          value: 'page',
          is_show: true,
          drop_down_values: [
            { label: 'Infinite scroll', value: 'scroll' },
            { label: 'Page by page', value: 'page' },
          ],
        },
      ],
      styles_fields: [
        {
          group_key: 'main_styles',
          group_title: 'Block styles',
          styles_list: [
            ...merge_default_values({
              all_items: common_card_styles_fields,
              default_values_items: [{ key: 'margin_bottom', value: '24px' }],
            }),
          ],
        },
        {
          group_key: 'box_styles',
          group_title: 'Content styles',
          styles_list: [
            ...merge_default_values({
              all_items: common_card_styles_fields,
              default_values_items: [],
            }),
          ],
        },
      ],
    },
  },
  {
    id: 11,
    title: 'Grid Cards',
    image: '/img/block-grid-cards.png',
    type: 'marketplace,single_shop',
    properties: {
      block: 'grid_card_block_top_image',
      block_data_key: '',
      fetch_by: {},
      isStatic: true,
      data_fields: [
        {
          key: 'enabled',
          title: 'card_block enabled',
          type: 'switch',
          value: true,
          isShowWithTitle: true,
        },

        {
          key: 'cards',
          title: 'Cards',
          type: 'array',
          value: [],
          drop_down_interface: {
            button_title: 'Add card',
            isShowTranslation: true,
            fields: [
              {
                key: 'title',
                title: 'Title',
                type: 'input',
                value: '',
                isShowValueInList: true,
                isShowTranslation: true,
              },
              {
                key: 'sub_title',
                title: 'Sub Title',
                type: 'input',
                value: '',
                isShowValueInList: true,
                isShowTranslation: true,
              },
              {
                key: 'desc',
                title: 'Description',
                type: 'input',
                value: '',
                isShowValueInList: true,
                isShowTranslation: true,
              },
              {
                key: 'image',
                title: 'Image',
                type: 'image',
                value: '',
              },
            ],
          },
          is_required: true,
        },
      ],
      styles_fields: [
        {
          group_key: 'main_styles',
          group_title: 'Block styles',
          styles_list: [
            ...merge_default_values({
              all_items: common_card_styles_fields,
              default_values_items: [{ key: 'margin_bottom', value: '24px' }],
            }),
          ],
        },
        {
          group_key: 'box_styles',
          group_title: 'Content Styles',
          styles_list: [...common_card_styles_fields, ...layout_styles],
        },
        {
          group_key: 'card_styles',
          group_title: 'Card',
          styles_list: [...common_card_styles_fields],
        },
        {
          group_key: 'row_styles',
          group_title: 'Image & Title Row',
          styles_list: [
            ...common_sizes_fields,
            ...merge_default_values({
              all_items: [
                ...spacing_styles,
                ...position_styles,
                ...background_styles,
                ...row_layout_styles,
              ],
              default_values_items: [{ key: 'columns_box_percentage', value: '48% 48%' }],
              remove_items: [],
            }),
          ],
        },
        {
          group_key: 'image',
          group_title: 'Image',
          styles_list: [...common_image_styles],
        },
        {
          group_key: 'title',
          group_title: 'Title',
          styles_list: [...typography_styles, ...spacing_styles],
        },
        {
          group_key: 'sub_title',
          group_title: 'Sub Title',
          styles_list: [...typography_styles, ...spacing_styles],
        },
        {
          group_key: 'desc',
          group_title: 'Description',
          styles_list: [...typography_styles, ...spacing_styles],
        },
      ],
    },
  },
  {
    id: 11,
    title: 'Title + Description + Button',
    image: '/img/block-dynamic_title+desc_button.png',
    type: 'marketplace,single_shop',
    properties: {
      block: 'dynamic_title_desc_button_top',
      block_data_key: '',
      fetch_by: {},
      isStatic: true,
      data_fields: [
        {
          key: 'title',
          title: 'Heading',
          type: 'input',
          value: '',
          is_required: true,
          isShowTranslation: true,
        },
        {
          key: 'description',
          title: 'Description',
          type: 'textarea',
          value: '',
          is_required: true,
          isShowTranslation: true,
        },
        {
          key: 'is_icon_in_right',
          title: 'Icon in right',
          type: 'switch',
          value: false,
        },
        {
          key: 'button_title',
          title: 'Button title',
          type: 'input',
          value: '',
          is_required: true,
          isShowTranslation: true,
        },
        {
          key: 'url',
          title: 'Button URL',
          type: 'input',
          value: '',
          is_required: true,
          default_values: common_button_links,
        },
        {
          key: 'button_target',
          title: 'Link open',
          type: 'select',
          value: '_parent',
          drop_down_values: link_target_values,
          required: true,
        },
        {
          key: 'icon',
          title: 'Icon URL',
          type: 'image',
          value: '',
          is_required: false,
        },
      ],
      styles_fields: [
        {
          group_key: 'main_styles',
          group_title: 'Block styles',
          styles_list: [
            ...merge_default_values({
              all_items: common_card_styles_fields,
              default_values_items: [{ key: 'margin_bottom', value: '24px' }],
            }),
          ],
        },
        {
          group_key: 'box_styles',
          group_title: 'Content Styles',
          styles_list: [...common_card_styles_fields, ...layout_styles],
        },
        {
          group_key: 'heading_text_styles',
          group_title: 'Heading text styles',
          styles_list: [
            ...merge_default_values({
              all_items: typography_styles,
              default_values_items: [
                { key: 'font_weight', value: '600' },
                { key: 'text_align', value: 'center' },
                { key: 'text_size', value: '60px' },
                { key: 'line_height', value: '' },
              ],
            }),
          ],
        },
        {
          group_key: 'description_text_styles',
          group_title: 'Description text styles',
          styles_list: [...typography_styles],
        },
        {
          group_key: 'button_styles',
          group_title: 'Button styles',
          styles_list: [...common_button_styles_fields],
        },

        {
          group_key: 'button_icon_styles',
          group_title: 'Icon styles',
          styles_list: [, ...common_image_styles],
        },
      ],
    },
  },
  {
    id: 11,
    title: 'Tally form',
    image: '/img/block-tally_form_block.png',
    type: 'marketplace,single_shop',
    properties: {
      block: 'tally_form_block',
      block_data_key: '',
      fetch_by: {},
      isStatic: true,
      data_fields: [
        {
          key: 'tally_src',
          title: 'Tally form URL',
          note: 'Copy full data-tally-src attribute from tally form and paste here',
          type: 'input',
          value: '',
          isShowTranslation: true,
        },
      ],
      styles_fields: [],
    },
  },
  {
    id: 11,
    title: 'HubSpot form',
    image: '/img/block-hubspot_form_block.png',
    type: 'marketplace,single_shop',
    properties: {
      block: 'hubspot_form_block',
      block_data_key: '',
      fetch_by: {},
      isStatic: true,
      data_fields: [
        {
          key: 'region',
          title: 'Region',
          type: 'input',
          value: '',
          is_required: true,
        },
        {
          key: 'portalId',
          title: 'Portal Id',
          type: 'input',
          value: '',
          is_required: true,
        },
        {
          key: 'formId',
          title: 'Form Id',
          type: 'input',
          value: '',
          is_required: true,
        },
      ],
      styles_fields: [
        {
          group_key: 'main_styles',
          group_title: 'Block styles',
          styles_list: [
            ...merge_default_values({
              all_items: common_card_styles_fields,
              default_values_items: [{ key: 'margin_bottom', value: '0px' }],
            }),
          ],
        },
      ],
    },
  },
  {
    id: 3,
    title: 'Subscription List',
    image: '/img/block-subscription_list.png',
    restricted_plans: ['community_monthly', 'starter_monthly'],
    type: 'marketplace,single_shop',
    properties: {
      block: 'subscription_list',
      block_data_key: 'subscription_list',
      fetch_by: {},
      isStatic: true,
      isShowTranslation: true,
      data_fields: [
        {
          key: 'title',
          title: 'Title',
          type: 'input',
          value: '',
          is_required: true,
          isShowTranslation: true,
        },
        {
          key: 'description',
          title: 'Description',
          type: 'textarea',
          value: '',
          is_required: true,
          isShowTranslation: true,
        },
      ],
      styles_fields: [
        {
          group_key: 'main_styles',
          group_title: 'Block styles',
          styles_list: [
            ...merge_default_values({
              all_items: common_card_styles_fields,
              default_values_items: [{ key: 'margin_bottom', value: '0px' }],
            }),
          ],
        },
      ],
    },
  },
  {
    id: 3,
    title: 'Subscription Card',
    image: '/img/block-subscription_by_card.png',
    type: 'marketplace,single_shop',
    restricted_plans: ['community_monthly', 'starter_monthly'],
    properties: {
      block: 'subscription_by_card',
      block_data_key: 'subscription_by_card',
      fetch_by: {},
      isStatic: true,
      data_fields: [
        {
          key: 'subscription_id',
          title: 'Select Subscription ',
          type: 'select',
          value: '',
          is_required: true,
          is_fetch_data: true,
          extra_data: {
            path: '/api/subscription',
            label_key: 'title',
            value_key: 'id',
          },
          drop_down_values: [],
        },
      ],
      styles_fields: [
        {
          group_key: 'main_styles',
          group_title: 'Block styles',
          styles_list: [
            ...merge_default_values({
              all_items: common_card_styles_fields,
              default_values_items: [{ key: 'margin_bottom', value: '0px' }],
            }),
          ],
        },
        {
          group_key: 'box_styles',
          group_title: 'Container styles',
          styles_list: [
            ...background_styles,
            ...common_sizes_fields,
            ...merge_default_values({
              all_items: common_card_styles_fields,
              default_values_items: [],
            }),

            ...merge_default_values({
              all_items: layout_styles,
            }),
          ],
        },
        {
          group_key: 'title_styles',
          group_title: 'Title styles',
          styles_list: [
            ...merge_default_values({
              all_items: typography_styles,
              default_values_items: [
                { key: 'font_weight', value: '600' },
                { key: 'text_align', value: 'center' },
                { key: 'text_size', value: '60px' },
                { key: 'line_height', value: '' },
              ],
            }),
          ],
        },
        {
          group_key: 'description_styles',
          group_title: 'Description styles',
          styles_list: [
            ...merge_default_values({
              all_items: typography_styles,
              default_values_items: [
                { key: 'font_weight', value: '600' },
                { key: 'text_align', value: 'center' },
                { key: 'text_size', value: '60px' },
                { key: 'line_height', value: '' },
              ],
            }),
          ],
        },
        {
          group_key: 'price_styles',
          group_title: 'Price styles',
          styles_list: [
            ...merge_default_values({
              all_items: typography_styles,
              default_values_items: [
                { key: 'font_weight', value: '600' },
                { key: 'text_align', value: 'center' },
                { key: 'text_size', value: '60px' },
                { key: 'line_height', value: '' },
              ],
            }),
          ],
        },
        {
          group_key: 'button_styles',
          group_title: 'Button styles',
          styles_list: [...common_button_styles_fields],
        },
      ],
    },
  },
  {
    id: 13,
    title: 'Text with icon',
    image: '/img/block-button.png',
    type: '',
    properties: {
      block: 'text_with_icon',
      isStatic: true,
      block_data_key: '',
      fetch_by: {},
      isShowTranslation: true,
      data_fields: [
        {
          key: 'isEnabled',
          title: '',
          type: 'switch',
          value: true,
          isShowWithTitle: true,
        },
        {
          key: 'text',
          title: 'Text',
          type: 'input',
          value: '',
          is_required: true,
          isShowTranslation: true,
        },

        {
          key: 'icon',
          title: 'Icon',
          type: 'image',
          value: '',
          is_required: false,
        },
      ],
      styles_fields: [
        {
          group_key: 'main_styles',
          group_title: 'Block styles',
          styles_list: [
            ...merge_default_values({
              all_items: common_card_styles_fields,
              default_values_items: [],
            }),
          ],
        },
        {
          group_key: 'box_styles',
          group_title: 'Container styles',
          styles_list: [
            ...background_styles,
            ...common_sizes_fields,
            ...merge_default_values({
              all_items: common_card_styles_fields,
              default_values_items: [],
            }),

            ...merge_default_values({
              all_items: layout_styles,
              remove_items: ['flex_direction', 'flex_wrap'],
            }),
          ],
        },

        {
          group_key: 'text_styles',
          group_title: 'Title text styles',
          styles_list: [...typography_styles],
        },
        {
          group_key: 'icon_styles',
          group_title: 'Icon styles',
          styles_list: [...common_image_styles],
        },
      ],
    },
  },
  {
    id: 13,
    title: 'Feature Checklist',
    image: '/img/block-features-list.png',
    type: '',
    properties: {
      block: 'feature_check_list',
      isStatic: true,
      block_data_key: '',
      fetch_by: {},
      data_fields: [
        {
          key: 'isEnabled',
          title: '',
          type: 'switch',
          value: true,
          isShowWithTitle: true,
        },
        {
          key: 'list',
          title: 'Features',
          type: 'array',
          value: [],
          drop_down_interface: {
            button_title: 'Add Feature',
            isShowTranslation: true,
            fields: [
              {
                key: 'text',
                title: 'Text',
                type: 'input',
                value: '',
                is_required: true,
                isShowTranslation: true,
                isShowValueInList: true,
              },
              {
                key: 'icon',
                title: 'Icon',
                type: 'image',
                value: '',
                is_required: true,
              },
            ],
          },
          is_required: true,
        },
      ],
      styles_fields: [
        {
          group_key: 'main_styles',
          group_title: 'Block styles',
          styles_list: [
            ...merge_default_values({
              all_items: common_card_styles_fields,
              default_values_items: [],
            }),
          ],
        },
        {
          group_key: 'box_styles',
          group_title: 'Content Styles',
          styles_list: [...common_card_styles_fields, ...layout_styles],
        },
        {
          group_key: 'list_styles',
          group_title: 'List',
          styles_list: [...common_card_styles_fields, ...layout_styles],
        },

        {
          group_key: 'text_styles',
          group_title: 'Title text styles',
          styles_list: [...typography_styles],
        },
        {
          group_key: 'icon_styles',
          group_title: 'Icon styles',
          styles_list: [
            ...common_image_styles,
            {
              key: 'box_shadow',
              default_component_key: 'shadow',
              value: '0px 1px 2px 0px #ffffff',
              type: 'shadow-picker',
              title: 'Shadow',
            },
          ],
        },
      ],
    },
  },
  {
    id: 13,
    title: 'Single Listing',
    image: '/img/single-listing-card-block.png',
    type: '',
    properties: {
      block: 'single_listing_card',
      isStatic: true,
      block_data_key: '',
      fetch_by: {},
      isShowTranslation: true,
      data_fields: [
        {
          key: 'isEnabled',
          title: '',
          type: 'switch',
          value: true,
          isShowWithTitle: true,
        },
        {
          key: 'slug',
          title: 'Select Listing',
          type: 'select',
          value: '',
          is_required: true,
          is_fetch_data: true,
          extra_data: {
            path: '/api/listings',
            label_key: 'title',
            value_key: 'slug',
          },
          drop_down_values: [],
        },
      ],
      styles_fields: [
        {
          group_key: 'main_styles',
          group_title: 'Block styles',
          styles_list: [
            ...merge_default_values({
              all_items: common_card_styles_fields,
              default_values_items: [],
            }),
          ],
        },
        {
          group_key: 'box_styles',
          group_title: 'Container styles',
          styles_list: [
            ...background_styles,
            ...common_sizes_fields,
            ...merge_default_values({
              all_items: common_card_styles_fields,
              default_values_items: [],
            }),

            ...merge_default_values({
              all_items: layout_styles,
              remove_items: ['flex_direction', 'flex_wrap'],
            }),
          ],
        },
      ],
    },
  },
  {
    id: 13,
    title: 'Accordion',
    image: '/img/block-accordion.png',
    type: '',
    properties: {
      block: 'accordion_block',
      isStatic: true,
      block_data_key: '',
      fetch_by: {},
      isShowTranslation: true,
      data_fields: [
        {
          key: 'isEnabled',
          title: '',
          type: 'switch',
          value: true,
          isShowWithTitle: true,
        },
        {
          key: 'right_icon',
          title: 'Right-Aligned Icon',
          type: 'switch',
          value: true,
        },
        {
          key: 'open_button_icon',
          title: 'Open Icon',
          type: 'image',
          value: '',
        },
        {
          key: 'close_button_icon',
          title: 'Close Icon',
          type: 'image',
          value: '',
        },
        {
          key: 'list',
          title: 'Accordion List',
          type: 'array',
          value: [],
          drop_down_interface: {
            button_title: 'Add Item',
            isShowTranslation: true,
            fields: [
              {
                key: 'title',
                title: 'Title',
                type: 'input',
                value: '',
                is_required: true,
                isShowValueInList: true,
                isShowTranslation: true,
              },

              {
                key: 'description',
                title: 'Description',
                type: 'textarea',
                value: '',
                isShowTranslation: true,
                is_required: true,
              },
            ],
          },
          is_required: true,
        },
      ],
      styles_fields: [
        {
          group_key: 'main_styles',
          group_title: 'Block styles',
          styles_list: [
            ...merge_default_values({
              all_items: common_card_styles_fields,
              default_values_items: [],
            }),
          ],
        },
        {
          group_key: 'box_styles',
          group_title: 'Container styles',
          styles_list: [...common_card_styles_fields, ...layout_styles],
        },

        {
          group_key: 'open_card_styles',
          group_title: 'Open Card styles',
          styles_list: [...common_card_styles_fields, ...layout_styles],
        },
        {
          group_key: 'close_card_styles',
          group_title: 'Close Card styles',
          styles_list: [...common_card_styles_fields, ...layout_styles],
        },
        {
          group_key: 'title_button_styles',
          group_title: 'Question styles',
          styles_list: [...typography_styles, ...common_card_styles_fields, ...layout_styles],
        },
        {
          group_key: 'description_styles',
          group_title: 'Description styles',
          styles_list: [...typography_styles, ...spacing_styles, common_sizes_fields],
        },
        {
          group_key: 'icon_styles',
          group_title: 'Icon styles',
          styles_list: [...common_image_styles],
        },
        ,
      ],
    },
  },
  {
    id: 6,
    title: 'Rich Text Composer',
    image: '/img/block-description.png',
    type: 'marketplace,single_shop',
    properties: {
      block: 'description_with_composer',
      block_data_key: '',
      fetch_by: {},
      isStatic: true,
      isShowTranslation: true,
      data_fields: [
        {
          key: 'enabled',
          title: '',
          type: 'switch',
          value: true,
          isShowWithTitle: true,
        },
        {
          key: 'description',
          title: 'Description',
          type: 'desc_composer',
          value: '',
          is_required: true,
          isShowTranslation: true,
        },
      ],
      styles_fields: [
        {
          group_key: 'main_styles',
          group_title: 'Block styles',
          styles_list: [
            ...merge_default_values({
              all_items: common_card_styles_fields,
              default_values_items: [
                { key: 'background', value: '' },
                { key: 'margin_bottom', value: '24px' },
              ],
            }),
          ],
        },
        {
          group_key: 'box_styles',
          group_title: 'Content styles',
          styles_list: [
            ...merge_default_values({
              all_items: common_card_styles_fields,
              default_values_items: [{ key: 'background', value: '' }],
            }),
          ],
        },
      ],
    },
  },
  {
    id: 6,
    title: 'Dynamic Code Block',
    image: '/img/block-custom_code.png',
    type: 'marketplace,single_shop',
    restricted_plans: ['community_monthly', 'starter_monthly'],
    properties: {
      block: 'dynamic_code_block',
      block_data_key: '',
      fetch_by: {},
      isStatic: true,

      data_fields: [
        {
          key: 'enabled',
          title: '',
          type: 'switch',
          value: true,
          isShowWithTitle: true,
        },
        {
          key: 'code',
          title: 'Code',
          type: 'code-textarea',
          value: '',
          is_required: true,
        },
      ],
      styles_fields: [],
    },
  },
  {
    id: 6,
    title: 'Notifications List',
    image: '/img/block-notifications.png',
    type: 'marketplace,single_shop',
    properties: {
      block: 'notifications_list',
      block_data_key: '',
      fetch_by: {},
      isStatic: true,

      data_fields: [
        {
          key: 'enabled',
          title: '',
          type: 'switch',
          value: true,
          isShowWithTitle: true,
        },
      ],
      styles_fields: [
        {
          group_key: 'main_styles',
          group_title: 'Block styles',
          styles_list: [
            ...merge_default_values({
              all_items: common_card_styles_fields,
              default_values_items: [
                { key: 'background', value: '' },
                { key: 'margin_bottom', value: '24px' },
              ],
            }),
          ],
        },
        {
          group_key: 'box_styles',
          group_title: 'Content styles',
          styles_list: [
            ...merge_default_values({
              all_items: common_card_styles_fields,
              default_values_items: [{ key: 'background', value: '' }],
            }),
          ],
        },
      ],
    },
  },
  {
    id: 13,
    title: 'Menu Link',
    image: '/img/block-menu-button.png',
    type: '',
    properties: {
      block: 'menu_cta',
      isStatic: true,
      block_data_key: '',
      fetch_by: {},
      isShowTranslation: true,
      data_fields: [
        {
          key: 'isEnabled',
          title: '',
          type: 'switch',
          value: true,
          isShowWithTitle: true,
        },
        {
          key: 'is_icon_in_right',
          title: 'Icon in right',
          type: 'switch',
          value: false,
        },
        {
          key: 'button_title',
          title: 'Button title',
          type: 'input',
          value: '',
          is_required: true,
          isShowTranslation: true,
        },
        {
          key: 'url',
          title: 'Button URL',
          type: 'input',
          value: '',
          is_required: true,
          default_values: common_button_links,
        },
        {
          key: 'button_target',
          title: 'Link open',
          type: 'select',
          value: '_parent',
          drop_down_values: link_target_values,
          required: true,
        },
        {
          key: 'icon',
          title: 'Icon URL',
          type: 'image',
          value: '',
          is_required: false,
        },
      ],
      styles_fields: [
        {
          group_key: 'main_styles',
          group_title: 'Block styles',
          styles_list: [
            ...merge_default_values({
              all_items: common_card_styles_fields,
              default_values_items: [],
            }),
          ],
        },
        {
          group_key: 'box_styles',
          group_title: 'Button styles',
          styles_list: [
            ...merge_default_values({
              all_items: [...common_card_styles_fields, ...row_layout_styles],
              default_values_items: [],
            }),
          ],
        },

        {
          group_key: 'text_styles',
          group_title: 'Title text styles',
          styles_list: [...typography_styles],
        },
        {
          group_key: 'icon_styles',
          group_title: 'Icon styles',
          styles_list: [, ...common_image_styles],
        },
      ],
    },
  },
  {
    id: 13,
    title: 'Logout Button',
    image: '/img/block-menu-logout.png',
    type: '',
    properties: {
      block: 'logout_cta',
      isStatic: true,
      block_data_key: '',
      fetch_by: {},
      isShowTranslation: true,
      data_fields: [
        {
          key: 'isEnabled',
          title: '',
          type: 'switch',
          value: true,
          isShowWithTitle: true,
        },
        {
          key: 'is_icon_in_right',
          title: 'Icon in right',
          type: 'switch',
          value: false,
        },
        {
          key: 'button_title',
          title: 'Button title',
          type: 'input',
          value: '',
          is_required: true,
          isShowTranslation: true,
        },
        {
          key: 'icon',
          title: 'Icon URL',
          type: 'image',
          value: '',
          is_required: false,
        },
      ],
      styles_fields: [
        {
          group_key: 'main_styles',
          group_title: 'Block styles',
          styles_list: [
            ...merge_default_values({
              all_items: common_card_styles_fields,
              default_values_items: [],
            }),
          ],
        },
        {
          group_key: 'box_styles',
          group_title: 'Button styles',
          styles_list: [
            ...merge_default_values({
              all_items: [...common_card_styles_fields, ...row_layout_styles],
              default_values_items: [],
            }),
          ],
        },

        {
          group_key: 'text_styles',
          group_title: 'Title text styles',
          styles_list: [...typography_styles],
        },
        {
          group_key: 'icon_styles',
          group_title: 'Icon styles',
          styles_list: [, ...common_image_styles],
        },
      ],
    },
  },
  {
    id: 6,
    title: 'Welcome User',
    image: '/img/block-welcome.png',
    type: 'marketplace,single_shop',
    properties: {
      block: 'welcome_heading_title',
      block_data_key: '',
      fetch_by: {},
      isStatic: true,
      isShowTranslation: true,
      data_fields: [
        {
          key: 'title',
          title: 'Heading',
          type: 'input',
          value: 'Welcome {user_name}',
          is_required: true,
          isShowTranslation: true,
        },
        {
          key: 'default_value',
          title: 'Default value',
          type: 'input',
          value: 'Guest',
          is_required: true,
          isShowTranslation: true,
        },
      ],
      styles_fields: [
        {
          group_key: 'main_styles',
          group_title: 'Block styles',
          styles_list: [
            ...merge_default_values({
              all_items: common_card_styles_fields,
              default_values_items: [{ key: 'background', value: '' }],
            }),
          ],
        },
        {
          group_key: 'box_styles',
          group_title: 'Content styles',
          styles_list: [
            ...merge_default_values({
              all_items: common_card_styles_fields,
              default_values_items: [{ key: 'background', value: '' }],
            }),
          ],
        },
        {
          group_key: 'text_styles',
          group_title: 'Heading text styles',
          styles_list: [
            ...merge_default_values({
              all_items: typography_styles,
              default_values_items: [
                { key: 'font_weight', value: '600' },
                { key: 'text_align', value: 'center' },
                { key: 'text_size', value: '60px' },
                { key: 'line_height', value: '' },
              ],
            }),
          ],
        },
      ],
    },
  },
  {
    id: 1,
    title: 'Global Order summary',
    image: '/img/block-checkout-order-summary.png',
    type: 'marketplace,single_shop',
    properties: {
      block: 'global_order_summary',
      block_code: 1,
      isStatic: true,
      block_data_key: '',
      fetch_by: {},
      data_fields: [
        {
          key: 'enabled',
          title: 'Enabled',
          type: 'switch',
          value: true,
          isShowWithTitle: true,
        },
        {
          key: 'show_title',
          title: 'Section Title',
          type: 'switch',
          value: true,
        },
      ],
      styles_fields: [
        {
          group_key: 'main_styles',
          group_title: 'Main styles',
          styles_list: [
            ...merge_default_values({
              all_items: common_card_styles_fields,
              default_values_items: [
                { key: 'padding_left', value: '16px' },
                { key: 'padding_right', value: '16px' },
                { key: 'padding_top', value: '18px' },
                { key: 'padding_bottom', value: '16px' },
                { key: 'top_left_border_radius', value: '8px' },
                { key: 'top_right_border_radius', value: '8px' },
                { key: 'bottom_left_border_radius', value: '8px' },
                { key: 'bottom_right_border_radius', value: '8px' },
              ],
            }),
          ],
        },
      ],
    },
  },
  {
    id: 1,
    title: 'Global Cart List',
    image: '/img/block-checkout-cart-list.png',
    type: 'marketplace,single_shop',
    properties: {
      block: 'global_cart_list',
      block_code: 1,
      isStatic: true,
      block_data_key: '',
      fetch_by: {},
      data_fields: [
        {
          key: 'enabled',
          title: 'Enabled',
          type: 'switch',
          value: true,
          isShowWithTitle: true,
        },
        {
          key: 'show_image',
          title: 'Image',
          type: 'switch',
          value: true,
        },
        {
          key: 'show_stock',
          title: 'Stock',
          type: 'switch',
          value: true,
        },
        {
          key: 'show_title',
          title: 'Title',
          type: 'switch',
          value: true,
        },

        {
          key: 'show_account_name',
          title: 'Account Name',
          type: 'switch',
          value: true,
        },
        {
          key: 'show_price',
          title: 'Price',
          type: 'switch',
          value: true,
        },
        {
          key: 'show_taxes',
          title: 'Tax',
          type: 'switch',
          value: true,
        },
        {
          key: 'show_action_buttons',
          title: 'Action Buttons',
          type: 'switch',
          value: true,
        },
      ],
      styles_fields: [
        {
          group_key: 'main_styles',
          group_title: 'Main styles',
          styles_list: [
            ...merge_default_values({
              all_items: common_card_styles_fields,
              default_values_items: [
                { key: 'padding_left', value: '16px' },
                { key: 'padding_right', value: '16px' },
                { key: 'padding_top', value: '18px' },
                { key: 'padding_bottom', value: '16px' },
                { key: 'top_left_border_radius', value: '8px' },
                { key: 'top_right_border_radius', value: '8px' },
                { key: 'bottom_left_border_radius', value: '8px' },
                { key: 'bottom_right_border_radius', value: '8px' },
              ],
            }),
          ],
        },
        {
          group_key: 'cart_item_styles',
          group_title: 'Cart Item styles',
          styles_list: [
            ...merge_default_values({
              all_items: common_card_styles_fields,
              default_values_items: [
                { key: 'padding_left', value: '16px' },
                { key: 'padding_right', value: '16px' },
                { key: 'padding_top', value: '18px' },
                { key: 'padding_bottom', value: '16px' },
                { key: 'top_left_border_radius', value: '8px' },
                { key: 'top_right_border_radius', value: '8px' },
                { key: 'bottom_left_border_radius', value: '8px' },
                { key: 'bottom_right_border_radius', value: '8px' },
              ],
            }),
          ],
        },
      ],
    },
  },
  {
    id: 1,
    title: 'Global Checkout Button',
    image: '/img/block-checkout-checkout.png',
    type: 'marketplace,single_shop',
    properties: {
      block: 'global_checkout_button',
      block_code: 1,
      isStatic: true,
      block_data_key: '',
      fetch_by: {},
      data_fields: [
        {
          key: 'enabled',
          title: 'Enabled',
          type: 'switch',
          value: true,
          isShowWithTitle: true,
        },
      ],
      styles_fields: [
        {
          group_key: 'main_styles',
          group_title: 'Main styles',
          styles_list: [
            ...merge_default_values({
              all_items: common_card_styles_fields,
              default_values_items: [
                { key: 'padding_left', value: '16px' },
                { key: 'padding_right', value: '16px' },
                { key: 'padding_top', value: '18px' },
                { key: 'padding_bottom', value: '16px' },
                { key: 'top_left_border_radius', value: '8px' },
                { key: 'top_right_border_radius', value: '8px' },
                { key: 'bottom_left_border_radius', value: '8px' },
                { key: 'bottom_right_border_radius', value: '8px' },
              ],
            }),
          ],
        },
      ],
    },
  },
  {
    id: 11,
    title: 'Static CardsWith Button',
    image: '/img/block-cards-top-with-button-image.png',
    type: 'marketplace,single_shop',
    properties: {
      block: 'card_block_top_image_with_button',
      block_data_key: '',
      fetch_by: {},
      isStatic: true,
      data_fields: [
        {
          key: 'enabled',
          title: 'card_block enabled',
          type: 'switch',
          value: true,
          isShowWithTitle: true,
        },

        {
          key: 'cards',
          title: 'Cards',
          type: 'array',
          value: [],
          drop_down_interface: {
            button_title: 'Add card',
            isShowTranslation: true,
            fields: [
              {
                key: 'image',
                title: 'Image',
                type: 'image',
                value: '',
              },
              {
                key: 'button_icon',
                title: 'Button icon',
                type: 'image',
                value: '',
                is_required: false,
              },
              {
                key: 'title',
                title: 'Title',
                type: 'input',
                value: '',
                isShowValueInList: true,
                isShowTranslation: true,
              },
              {
                key: 'desc',
                title: 'Description',
                type: 'textarea',
                value: '',
                isShowValueInList: true,
                isShowTranslation: true,
              },
              // {
              //   key: 'is_icon_in_right',
              //   title: 'Button Icon in right',
              //   type: 'switch',
              //   value: false,
              // },
              {
                key: 'button_title',
                title: 'Button title',
                type: 'input',
                value: '',
                is_required: true,
                isShowTranslation: true,
              },
              {
                key: 'url',
                title: 'Button URL',
                type: 'input',
                value: '',
                is_required: true,
                default_values: common_button_links,
              },
              {
                key: 'button_target',
                title: 'Link open',
                type: 'select',
                value: '_parent',
                drop_down_values: link_target_values,
                required: true,
              },
            ],
          },
          is_required: true,
        },
      ],
      styles_fields: [
        {
          group_key: 'main_styles',
          group_title: 'Block styles',
          styles_list: [
            ...merge_default_values({
              all_items: common_card_styles_fields,
              default_values_items: [{ key: 'margin_bottom', value: '24px' }],
            }),
          ],
        },
        {
          group_key: 'box_styles',
          group_title: 'Content Styles',
          styles_list: [...common_card_styles_fields, ...layout_styles],
        },
        {
          group_key: 'card_styles',
          group_title: 'Card',
          styles_list: [...common_card_styles_fields],
        },
        {
          group_key: 'image',
          group_title: 'Image',
          styles_list: [...common_image_styles],
        },
        {
          group_key: 'title',
          group_title: 'Title',
          styles_list: [...typography_styles, ...spacing_styles],
        },
        {
          group_key: 'desc',
          group_title: 'Description',
          styles_list: [...typography_styles, ...spacing_styles],
        },
        {
          group_key: 'button_styles',
          group_title: 'Button ',
          styles_list: [
            ...merge_default_values({
              all_items: [...common_card_styles_fields, ...row_layout_styles],
              default_values_items: [],
            }),
          ],
        },

        {
          group_key: 'button_text_styles',
          group_title: 'Button text',
          styles_list: [...typography_styles],
        },
        {
          group_key: 'button_icon_styles',
          group_title: 'Button Icon',
          styles_list: [, ...common_image_styles],
        },
      ],
    },
  },
  {
    id: 3,
    title: 'Dynamic Listings By Category',
    image: '/img/block-all-listings.png',
    type: 'marketplace,single_shop',
    properties: {
      block: 'dynamic_listings_by_category',
      block_data_key: 'listings',
      fetch_by: {},
      isStatic: true,
      data_fields: [
        {
          key: 'attributes_includes',
          title: 'Load Attributes',
          type: 'switch',
          value: false,
          is_required: false,
        },
        {
          key: 'listing_card_type',
          title: 'Listing Card',
          type: 'listing_card_type',
          value: 'default',
        },
      ],
      styles_fields: [
        {
          group_key: 'main_styles',
          group_title: 'Block styles',
          styles_list: [
            ...merge_default_values({
              all_items: common_card_styles_fields,
              default_values_items: [{ key: 'margin_bottom', value: '24px' }],
            }),
          ],
        },
        {
          group_key: 'box_styles',
          group_title: 'Content styles',
          styles_list: [
            ...merge_default_values({
              all_items: common_card_styles_fields,
              default_values_items: [],
            }),
          ],
        },
      ],
    },
  },
  {
    id: 4,
    title: 'Sub Categories Filter (Listing By Category page Only)',
    image: '/img/block-category-grid-tab.png',
    type: 'marketplace,single_shop',
    properties: {
      block: 'filters_by_sub_category',
      block_data_key: '',
      fetch_by: {},
      isStatic: true,
      data_fields: [
        {
          key: 'parent_label',
          title: 'Parent Label First',
          type: 'switch',
          value: true,
          is_required: true,
        },
        {
          key: 'show_parent_category',
          title: 'Show Parent Category',
          type: 'switch',
          value: true,
        },
        // parent and child join string
        {
          key: 'join_with',
          title: 'Join with',
          type: 'input',
          value: ' → ',
          is_required: true,
        },
      ],
      styles_fields: [
        {
          group_key: 'main_styles',
          group_title: 'Block styles',
          styles_list: [
            ...merge_default_values({
              all_items: [...common_card_styles_fields, ...row_layout_styles],
            }),
          ],
        },
        {
          group_key: 'button_styles',
          group_title: 'Category Button styles',
          styles_list: [...common_button_styles_fields],
        },
      ],
    },
  },
]

export const page_main_styles = [
  {
    group_key: 'main_styles',
    group_title: 'Main styles',
    styles_list: [
      ...merge_default_values({
        all_items: [
          ...common_sizes_fields,
          ...spacing_styles,
          ...background_styles,
          ...typography_styles,
          ...border_styles,
        ],
        default_values_items: [
          { key: 'background', value: '#F5F5F5' },
          { key: 'width', value: '100%' },
        ],
      }),
    ],
  },
  {
    group_key: 'box_styles',
    group_title: 'Content styles',
    styles_list: [
      ...common_sizes_fields,
      ...background_styles,
      ...typography_styles,
      ...border_styles,
      ...merge_default_values({
        all_items: spacing_styles,
        default_values_items: [
          { key: 'padding_bottom', value: '16px' },
          { key: 'padding_right', value: '16px' },
          { key: 'padding_left', value: '16px' },
          { key: 'margin_top', value: '16px' },
          { key: 'margin_bottom', value: '16px' },
          { key: 'max_width', value: '1400px' },
        ],
      }),
      {
        key: 'box_shadow',
        default_component_key: 'shadow',
        value: '',
        type: 'shadow-picker',
        title: 'Shadow',
      },
      {
        key: 'gap',
        title: 'Gap between rows',
        type: 'input-px',
        value: '24px',
        is_required: false,
      },
    ],
  },
]

//
export const row_col_styles = [
  {
    group_key: 'row_styles',
    group_title: 'Row styles',
    styles_list: [
      ...common_sizes_fields,
      ...merge_default_values({
        all_items: [
          ...spacing_styles,
          ...position_styles,
          ...background_styles,
          ...row_layout_styles,
          ...border_styles,
        ],
        default_values_items: [],
        remove_items: [],
      }),
    ],
  },
  {
    group_key: 'column_styles',
    group_title: 'Column {value} styles',
    styles_list: [
      ...merge_default_values({
        all_items: spacing_styles,
        default_values_items: [],
      }),
      ...position_styles,
      ...common_sizes_fields,
      ...background_styles,
      ...border_styles,
      ...merge_default_values({
        all_items: layout_styles,
        default_values_items: [
          { key: 'align_items', value: 'stretch', key: 'flex_direction', value: 'column' },
        ],
      }),

      {
        key: 'box_shadow',
        default_component_key: 'shadow',
        value: '0px 0px 0px 0px #ffffff',
        type: 'shadow-picker',
        title: 'Shadow',
      },
    ],
  },
]
